module.exports = __webpack_public_path__ + "f0cd280d5f17410aa32f18042e271278.pdf";